
export function preparePlaceDropdown(floors = []) {
    if (floors.length === 0) return;
    return floors.map((floor) => ({
        label: floor.name,
        value: floor.id
    }));
}

export function prepareStaffDropdown(staffs = []) {
    if (staffs.length === 0) return;
    return staffs.map((staff) => ({
        label: staff.name,
        value: staff.staffId
    }));
}

export function prepareTableAndStaffList(tables = []) {
    if (tables.length === 0) return [];
    return tables.filter(table => table.id !== "").map((table) => ({
        id: table.id,
        tableNo: table.name,
        place: table.floor.name,
        staffName: table?.staff?.name || ""
    }));
}

export function getTablesWithFloorId(floors = [], floorId = "", initStaff = null) {
    if (floors.length === 0 || floorId === "") return;
    const tables = [];
    const currentFloorTables = floors.find((floor) => floor.id === floorId)?.tables || [];
    if (currentFloorTables.length === 0) return;

    currentFloorTables.forEach(table => {
        const staff = table?.assignedStaff ?? initStaff ?? { staffId: "", name: "" };
        tables.push({
            objId: crypto.randomUUID(),
            id: table.id,
            tableName: table.name,
            staffId: staff.staffId,
            staffName: staff.name
        });
    });

    return tables;
}